import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './data.css';
import { Form, Icon, Statistic, Button, DatePicker, message } from 'antd';
import { Breadcrumb, Table } from 'antd';
import moment from 'moment';
import TableEmpty from '../components/TableEmpty.js';
import echarts from 'echarts/lib/echarts';
// 引入柱状图
import 'echarts/lib/chart/bar';
// 引入饼图
import 'echarts/lib/chart/pie';
//引入图例组件
import 'echarts/lib/component/legend';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';

import { formatDate, changeListWidth, breadItem } from '../utils';
import { calcTableHeight } from '../utils';
import { apis } from '../api/index.js';

import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
const { MonthPicker } = DatePicker;

class Report extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    form: PropTypes.object,
  };

  componentDidMount() {
    this.setState({ date: new Date() }, () => this.serviceCountList());
    this.props.form.setFieldsValue({
      monthDate: moment(new Date(), 'YYYY年MM月'),
    });

    const newHeight = calcTableHeight(189) || 0;
    this.setState({ tableHeight: newHeight });
  }

  serviceCountList = () => {
    const { date } = this.state; //日历当前时间
    const range = formatDate(date, 'YYYY-MM');

    const [year, month] = [range.split('-')[0], range.split('-')[1]];
    const lastDay = new Date(year, month, 0).getDate();

    const fromTime = range + '-01';
    const toTime = range + '-' + lastDay;

    apis.serviceCountList(fromTime, toTime).then(res => {
      if (res.code === '0') {
        this.setState({ data: res.data }, () => {
          this.setBarOption();
          this.setPieOption();
        });
      } else message.error(res.message);
    });
  };

  handleSearch = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.serviceCountList();
      }
    });
  };

  handleReset = () => {
    this.props.form.setFieldsValue({
      monthDate: moment(new Date(), 'YYYY年MM月'),
    });
    this.setState({ date: new Date() });
  };

  setBarOption = () => {
    const { data } = this.state;
    let data1 = [
      data.correctReportsSum,
      data.logicErrorsSum,
      data.generalErrorsSum,
      data.seriousErrorsSum,
    ];
    const option = {
      title: {
        text: '报告质量统计',
        left: 'center',
        textStyle: { color: '#333333', fontSize: 16, fontWeight: 'bold' },
      },
      color: ['#5B8FF9'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      grid: { left: '3%', right: 80, bottom: '3%', containLabel: true },
      xAxis: [
        {
          type: 'category',
          axisLabel: { color: '#666666', fontSize: 12 },
          axisLine: { lineStyle: { color: '#ACD6FF' }, width: 1 },
          axisTick: { show: false },

          data: ['报告正确完整', '用语不当/逻辑欠妥', '一般性差错', '严重差错'],
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: { color: '#666666', fontSize: 12 },
          axisLine: {
            lineStyle: { color: 'rgba(0,0,0,0)' },
            width: 5,
          },
          axisTick: { show: false },
          splitLine: { lineStyle: { color: '#D6EBFF' } },
        },
      ],
      series: [{ name: '人数', type: 'bar', barWidth: 15, data: data1 }],
    };
    const diseaseChart = echarts.init(document.getElementById('bar'));
    diseaseChart.setOption(option);
  };

  setPieOption = () => {
    const { data } = this.state;
    const pieChart = echarts.init(document.getElementById('pie'));
    const option = {
      title: {
        text: '影像质量统计',
        left: 'center',
        textStyle: { color: '#333333', fontSize: 16, fontWeight: 'bold' },
      },
      color: ['#719EF8', '#DA733B', '#E98292', '#EFCF70', '#E97C63', '#7585A2'],
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },
      // toolbox: { show: false },
      legend: {
        type: 'plain',
        right: 10,
        bottom: 10,
        orient: 'vertical',
        icon: 'circle',
      },
      series: [
        {
          name: '影像质量统计',
          type: 'pie',
          hoverAnimation: false,
          selectedOffset: 0,
          data: [
            { value: data.normalNumsSum, name: '影像正常' },
            { value: data.underexposedNumsSum, name: '曝光不足' },
            { value: data.foreignNumsSum, name: '体外异物伪影' },
            { value: data.blurNumsSum, name: '图像模糊' },
            { value: data.overexposedNumsSum, name: '曝光过度' },
            { value: data.noPointNumsSum, name: '关键点未包全' },
          ],
          labelLine: { show: false },
          label: { show: false },
        },
      ],
    };
    pieChart.setOption(option);
  };

  getColumns = () => {
    const columns = [];
    columns.push(
      {
        title: '日期',
        dataIndex: 'recordTime',
        key: 'recordTime',
      },
      {
        title: '报告数',
        dataIndex: 'reportNums',
        key: 'reportNums',
      },
      {
        title: '审核数',
        dataIndex: 'auditNums',
        key: 'auditNums',
      },
      {
        title: '平均诊断时长',
        dataIndex: 'dayDiagnosisTime',
        key: 'dayDiagnosisTime',
      },
      {
        title: '平均审核时长',
        dataIndex: 'dayAuditTime',
        key: 'dayAuditTime',
      },
      {
        title: '报告质量统计',
        children: [
          {
            title: '报告正确完整数',
            dataIndex: 'correctReports',
            key: 'correctReports',
          },
          {
            title: '用语不当/逻辑欠妥数',
            dataIndex: 'logicErrors',
            key: 'logicErrors',
          },
          {
            title: '一般性差错',
            dataIndex: 'generalErrors',
            key: 'generalErrors',
          },
          {
            title: '严重差错数',
            dataIndex: 'seriousErrors',
            key: 'seriousErrors',
          },
        ],
      },
      {
        title: '图像质量统计',
        children: [
          {
            title: '影像正常',
            dataIndex: 'normalNums',
            key: 'normalNums',
          },
          {
            title: '曝光不足',
            dataIndex: 'underexposedNums',
            key: 'underexposedNums',
          },
          {
            title: '体外异物伪影',
            dataIndex: 'foreignNums',
            key: 'foreignNums',
          },
          {
            title: '图像模糊',
            dataIndex: 'blurNums',
            key: 'blurNums',
          },
          {
            title: '曝光过度',
            dataIndex: 'overexposedNums',
            key: 'overexposedNums',
          },
          {
            title: '关键点未包全',
            dataIndex: 'noPointNums',
            key: 'noPointNums',
          },
        ],
      }
    );

    return columns;
  };

  onChange = (date, dateString) => {
    this.setState({ dateString, date });
  };

  export = () => {
    const { date } = this.state; //日历当前时间
    const range = formatDate(date, 'YYYY-MM');

    const [year, month] = [range.split('-')[0], range.split('-')[1]];
    const lastDay = new Date(year, month, 0).getDate();

    const fromTime = range + '-01';
    const toTime = range + '-' + lastDay;
    window.location.href = `/ai-web/report/service/export-excel?beginTime=${fromTime}&endTime=${toTime}`;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, tableHeight } = this.state;
    const columns = this.getColumns();
    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>
                {breadItem(['数据看板', '远程诊断报告分析'])}
              </Breadcrumb>
            </div>
            <div className="box" style={{ width: this.state.listWidth }}>
              <div className="data-search">
                <Form layout="inline">
                  <Form.Item label="日期选择">
                    {getFieldDecorator('monthDate', {})(
                      <MonthPicker
                        allowClear={true}
                        placeholder="请选择月份"
                        format="YYYY年MM月"
                        onChange={this.onChange}
                      />
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Button type="primary" onClick={this.handleSearch}>
                      <Icon type="search" />
                      搜索
                    </Button>
                    <Button icon="redo" onClick={this.handleReset}>
                      重置
                    </Button>
                  </Form.Item>
                </Form>
              </div>
              <div className="data-statistical">
                <Statistic
                  className="item item1"
                  title="报告数（按部位）"
                  value={data.reportNumsSum || 0}
                  precision={0}
                  valueStyle={{ color: '#ffffff' }}
                  suffix="份"
                />
                <Statistic
                  className="item item2"
                  title="审核报告数（按部位）"
                  value={data.auditNumsSum || 0}
                  precision={0}
                  valueStyle={{ color: '#ffffff' }}
                  suffix="份"
                />
                <div className="item item3">
                  <p>平均诊断时长（按部位）</p>
                  <p>
                    <i>{parseInt((data.dayDiagnosisTimeSum || 0) / 60)}</i>分
                    <i>{(data.dayDiagnosisTimeSum || 0) % 60}</i>秒
                  </p>
                </div>
                <div className="item item3">
                  <p>平均审核时长（按部位）</p>
                  <p>
                    <i>{parseInt((data.dayAuditTimeSum || 0) / 60)}</i>分
                    <i>{(data.dayAuditTimeSum || 0) % 60}</i>秒
                  </p>
                </div>
              </div>
              <div className="data-report-charts">
                <div id="bar" style={{ height: 300 }}></div>
                <div id="pie" style={{ height: 300 }}></div>
              </div>
              <div className="history-list">
                <div className="export-box">
                  <Button type="default" onClick={this.export}>
                    导出全部
                  </Button>
                </div>
                <Table
                  columns={columns}
                  dataSource={data.reportCountItemVOList}
                  rowKey={record => record.id}
                  key={record => record.id}
                  className="list-item"
                  scroll={{ y: tableHeight }}
                  bordered
                  locale={{ emptyText: <TableEmpty /> }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(Report));
